import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FlippingCard from './FlippingCard';
import SubcategoryModal from './SubcategoryModal';

export default function SimchaSection({ categories }) {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const wrapRef = useRef(null);
  const [showSubcategoryModal, setShowSubcategoryModal] = useState(false);

  // Handle category card click with warp-out effect
  function handleCategoryClick(e, friendlyUrlName) {
    e.preventDefault();

    // Show modal for Shidduch category instead of navigating
    if (friendlyUrlName === 'its-a-shidduch') {
      setShowSubcategoryModal(true);
      return;
    }

    if (!wrapRef.current) return;

    const cards = Array.from(wrapRef.current.querySelectorAll('.categories-card'));
    const clickedIdx = cards.indexOf(e.currentTarget);

    cards.forEach((card, i) => {
      const dist = Math.abs(i - clickedIdx);
      const delay = dist * 45;
      card.style.transition = [
        `transform 0.42s cubic-bezier(0.35,0,0,1) ${delay}ms`,
        `filter 0.42s cubic-bezier(0.35,0,0,1) ${delay}ms`,
        `opacity 0.38s ease ${delay}ms`,
      ].join(', ');

      if (i === clickedIdx) {
        card.style.transform = 'perspective(700px) scale(1.18) translateY(-18px) rotateX(-7deg)';
        card.style.filter = 'blur(3px)';
      } else {
        const col = i % 3;
        const row = Math.floor(i / 3);
        const tiltX = row === 0 ? '-12deg' : '12deg';
        const tiltY = col === 0 ? '-8deg' : col === 2 ? '8deg' : '0deg';
        card.style.transform = `perspective(700px) scale(0.5) translateY(${row % 2 === 0 ? '-20px' : '20px'}) rotateX(${tiltX}) rotateY(${tiltY})`;
        card.style.filter = 'blur(7px)';
      }
      card.style.opacity = '0';
    });

    setTimeout(() => navigate(`/categories/${friendlyUrlName}`), 520);
  }


  const CATEGORY_IMAGE = {
    'its-a-boy': '/category-icons/boy.png',
    'its-a-girl': '/category-icons/girl.png',
    'its-an-upsherin': '/category-icons/upsherin.png',
    'its-a-shidduch': '/category-icons/shidduch.png',
    'its-a-bar-mitzvah': '/category-icons/bar-mitzvah.png',
    'its-something-else': '/category-icons/something-else.png',
  };

  return (
    <>
      <section id="chooseCategorysec" className="categories-container-home simcha-section" ref={sectionRef}>
        <h2 className="category-hd">So… what are we celebrating?</h2>

        <div className="categories-flex-home">
          <div className="category-wrap" ref={wrapRef}>
            {categories.map(c => {
              const imgSrc = CATEGORY_IMAGE[c.friendlyUrlName];
              return (
                <div
                  key={c._id}
                  className="categories-card-wrapper"
                  onClick={(e) => handleCategoryClick(e, c.friendlyUrlName)}
                >
                  <FlippingCard
                    frontContent={
                      <div className="categories-card">
                        {imgSrc ? (
                          <img src={imgSrc} alt="" className={`cat-img cat-img-${c.friendlyUrlName}`} />
                        ) : (
                          <div className="cat-icon">
                            {c.name?.[0] || '•'}
                          </div>
                        )}
                        <div className="cat-name">{c.name}</div>
                      </div>
                    }
                    backContent={
                      <h3>{c.name}</h3>
                    }
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <SubcategoryModal
        isOpen={showSubcategoryModal}
        onClose={() => setShowSubcategoryModal(false)}
      />
    </>
  );
}
